<template lang="pug">
textarea.fieldset__input.--textarea(
  ref="textarea"
  rows="1"
  :class="classes"
  :name="name"
  :id="name"
  :maxlength="maxlength"
  :placeholder="placeholder"
  :title="error ? error : ''"
  v-model="internalValue"
  v-on="inputListeners"
)
</template>

<script>
export default {
  name: 'fieldset__input--textarea',
  props: {
    wide: {
      type: Boolean,
      default: false,
    },
    preventNewlines: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalValue: null,
    }
  },
  watch: {
    value(val, old) {
      if (val === old) return
      this.internalValue = this.preventNewlines ? val.replace(/\n/g, '') : val
    },
    internalValue(val, old) {
      if (val === old || old === null) return
      if (this.preventNewlines) {
        this.internalValue = val.replace(/\n/g, '')
        this.$nextTick(() => this.resize())
        return
      }
      this.resize()
    },
  },
  computed: {
    classes() {
      return {
        '--wide': this.wide,
        '--empty': !this.value,
        '--error': !!this.error,
      }
    },
    inputListeners() {
      const vm = this
      return Object.assign({}, this.$listeners, {
        input() {
          vm.$emit('input', vm.internalValue)
        },
        change() {
          vm.$emit('change', vm.internalValue)
        },
      })
    },
  },
  methods: {
    resize() {
      const field = this.$refs.textarea
      field.style.height = 'auto'
      const height = field.scrollHeight + 1
      field.style.height = `${height}px`
    },
    focus() {
      this.$refs.textarea.focus()
    },
  },
  mounted() {
    this.internalValue = this.value
    this.$nextTick(() => this.resize())
  },
}
</script>

<style lang="sass">
.fieldset__input
  &.--textarea
    min-height: calc((var(--input-fontsize) * var(--input-lineheight)) + (var(--input-padding-v) * 2))
    resize: none
    transition: background-size 0.3s, background-image 0.3s, border-color 0.3s, height 0.3s
</style>
